export default {
  userReport: {
    date: "报表日期",
    userName: "账号",
    proxyName: "上级",
    userSubNum: "直属下级数",
    userAllSubNum: "成员数 ",
    betCount: "下注笔数",
    amount: "投注金额",
    validAmount: "实际投注金额",
    rebateMoney: "返水金额",
    userResult: "用户输赢（不含退水）",
    rebateAmount: "退水 ",
    result: "用户实际输赢",
    platformCode: "所属平台",
    userId: "用户账号",
    proxyId: "所属上级",
    dateSearch: "时间",
    refreshData: "刷新数据",
    refresh: "刷新数据",
    datePlaceholder: "请选择一个日期",
    pumpingAmount: "奖金抽水",
    activityPumping: "活动抽水",
    incomeAmount: "派奖金额",
    returnAmountCount: "退还金额/次数",
  },
  platformReport: {
    date: "报表日期",
    regCount: "新增注册",
    validUserCount: "有效用户平均数",
    balance: "平台平均余额",
    member: "充提",
    rechargeAmount: "充值金额",
    withdrawAmount: "提现金额",
    betCount: "下注笔数",
    betCountTitle: "下注笔数/待结算/撤单",
    betRebateAmount: "投注/退水金额",
    betAmount: "投注金额",
    rebateAmount: "退水金额",
    validAmount: "实际投注金额",
    pumpingAmount: "奖金抽水",
    activityPumping: "活动抽水",
    userGainLoss: "用户输赢（含退水）",
    backAmount: "返水金额",
    activityAmount: "活动金额",
    platformGainLoss: "平台盈亏",
    platformCode: "所属平台",
    dateSearch: "时间",
    day: "日",
    week: "周",
    month: "月",
    year: "年",
    amount: "金额",
    amountType1: "充值",
    amountType2: "提现",
    amountType3: "投注",
    isWin: "用户输赢",
    win: "赢",
    lose: "输",
    refreshData: "刷新数据",
    refresh: "刷新数据",
    datePlaceholder: "请选择一个日期",
    refreshMessage: "数据刷新需要较长时间，请耐心等待",
    userInfo: "用户信息",
    nickName: "用户昵称",
    account: "用户账号",
    createTime: "注册时间",
    registerIp: "ip地址",
    ipAddress: "国家",
    option: "操作",
    info: "详情",
    registerTitle: "新增注册",
  },
  gameReport: {
    game: "游戏",
    betNum: "笔数",
    userBetNum: "注单人数",
    amount: "投注金额",
    validAmount: "实际投注金额",
    rebateMoney: "返水总金额",
    pumpingAmount: "奖金抽水",
    activityPumping: "活动抽水",
    userResult: "用户输赢（不含退水）",
    rebateAmount: "用户退水",
    result: "用户实际输赢",
    platformCode: "所属平台",
    date: "时间",
  },
  cashReport: {
    date: "报表日期",
    userName: "账号",
    rechargeAmount: "充值金额",
    rechargeNum: "充值次数",
    increaseAmount: "后台加钱",
    withdrawAmount: "提现金额",
    withdrawNum: "提现次数",
    decreaseAmount: "后台扣钱",
    betAmount: "投注金额(含退水)",
    betAmountCount: "投注金额(含退水)/次数",
    validAmount: "实际投注金额",
    betGainLossAmount: "投注盈亏总金额",
    gainLossAmount: "用户盈亏总金额",
    activityAwardAmountTitle: "活动奖励/次数",
    balance: "账户余额",
    platformCode: "所属平台",
    userId: "用户账号",
    dateSearch: "时间",
    refreshData: "刷新数据",
    refresh: "刷新数据",
    datePlaceholder: "请选择一个日期",
    refreshMessage: "数据刷新需要较长时间，请耐心等待",
    returnAmountCount: "退还金额/次数",
    incomeAmount: "派奖金额",
    frozenAmountCount: "冻结金额/次数",
    thawAmountCount: "解冻金额/次数",
  },
  settlementReport: {
    platformCode: "所属平台",
    platformGainLossTotal: "平台总盈亏",
    betAmountTotal: "总流水（投注金额）",
    betValidAmountTotal: "实际总流水（实际投注金额）",
    pumpingRatio: "当前盈亏抽成比例",
    gamePumpingRatio: "当前流水抽成比例",
    pumpingAmountTotal: "抽成金额1",
    pumpingAmountTotalTip1: "非控盘平台类型抽水金额=平台总盈亏x盈亏抽成比例",
    pumpingAmountTotalTip2: "控盘平台类型抽水金额=平台盈亏（不包含大小3分钟）x盈亏抽成比例",
    gamePumpingAmountTotal: "抽成金额2（大小3分钟流水）",
    gamePumpingAmountTotalTip1: "游戏流水（大小3分钟）x当前流水抽成比例",
    dx3MinValidAmount: "游戏流水（大小3分钟）",
    dx3MinExcludePlatformGainLoss: "平台盈亏（不包含大小3分钟游戏）",
    pumpingTotalAmount: "抽成总金额",
    option: "操作",
    date: "时间",
    platformGainLoss: "平台盈亏",
    betAmount: "流水（投注金额）",
    pumpingAmount: "抽成金额",
    refresh: "刷新",
  },
  activityReport: {
    title1: "活动明细报表",
    title2: "活动汇总/日",
    title3: "活动汇总/人",
    createTime: "领取时间",
    account: "账号",
    awardAmount: "领取奖励",
    activityId: "参与活动类型",
    activityType: "活动类型",
    awardAmountSum: "日领取奖励"
  }

}
